import { getPhotosForPhotowall } from 'entities/photos';

Pixlee.module('MosaicV2App.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var _this = this;
            var photosCollection = getPhotosForPhotowall();
            var currentAlbum = App.currentAlbum;
            var layout = this.getLayout(photosCollection);
            var renderedCollection = getPhotosForPhotowall(false);
            this.listenTo(layout, 'show', function() {
                var collectionView = this.getCollectionView({
                    collection: renderedCollection,
                    collectionQueue: photosCollection,
                    displayOptions: options.display_options
                });
                if (!_.isFalsy(options.display_options.is_interactive)) {
                    var navbarView = this.getNavbarView(options, photosCollection);
                    this.showView(navbarView, layout.interactiveRegion);
                }
                this.showView(collectionView, layout.frame);
                layout.triggerMethod('init:isotope');
                var headerLayout = _.isFalsy(options.display_options.headerOptions) ? '' : options.display_options.headerOptions.layout;

                var headerView = this.getHeaderView(currentAlbum);
                this.showView(headerView, layout.widgetHeaderRegion);
                photosCollection.on('sync', function(collection, resp) {
                    if (_this.widgetLoaded) {
                        return false;
                    }
                    _this.widgetLoaded = true;
                    gon.sortType = resp.sortType;
                    var unionIds = _.union(renderedCollection.pluck('album_photo_id'), collection.pluck('album_photo_id'));
                    var albumPhotoIds = unionIds.filter(function(n) {
                        return n != undefined;
                    });
                    App.commands.execute('opened:photowall', albumPhotoIds, true);
                });
            });
            this.showLayout(layout);
        },
        getLayout: function(photosCollection) {
            return new Show.Layout({
                collection: photosCollection
            });
        },
        getCollectionView: function(options) {
            return new Show.MosaicCollection(options);
        },
        getHeaderView: function(currentAlbum) {
            return new Show.HeaderView({
                model: currentAlbum
            });
        },
        getNavbarView: function(options, photosCollection) {
            return App.request('get:navbar:view', options, photosCollection);
        },
        showLayout: function(layoutView) {
            this.show(layoutView);
        },
        showView: function(view, region) {
            this.show(view, {
                region: region
            });
        },
    });

});
